import { GOOGLE_ADS } from '../constants';

export function dispararConversaoWhatsApp(callback?: () => void) {
    if (typeof window === 'undefined') {
        callback?.();
        return;
    }

    let callbackExecutado = false;

    const executarCallback = () => {
        if (!callbackExecutado && callback) {
            callbackExecutado = true;
            callback();
        }
    };

    if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
            event: 'whatsapp_click',
            send_to: GOOGLE_ADS.conversionId,
            event_callback: executarCallback,
            event_timeout: 1500
        });
    }

    if (window.gtag) {
        window.gtag('event', 'conversion', {
            send_to: GOOGLE_ADS.conversionId,
            event_callback: executarCallback,
            event_timeout: 1500
        });
    }

    window.setTimeout(executarCallback, 1500);
}